export const MYLIST_APP = {
    S3_BUCKET_HOST: 'https://my-list-images.s3.amazonaws.com',
    SECTIONS: {
        POPULAR: 'Popular',
        ACTIVITIES: 'Browse',
        CREATE_ITEM: 'Create Item',
        LOGIN: 'Login,'
    }
}